import React, {PureComponent as Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import {Col, Button} from 'reactstrap';
import moment from 'moment';
moment.locale("en");

export default class Footer extends Component{
    render(){
        return(
            <div>
                <Col xs={12} md={12} className="section note text-center">
                    <p>Please pay before <strong>{moment(this.props.expire).format('dddd, LL HH:mm')}</strong>.</p>
                    
                </Col>
                <Col xs={12} className="button-wrapper full-width-wrapper">
                   
                    <Button
                        className="btn-green bold"
                        color="success"
                        size="lg"
                        block
                        onClick={this.props.onClick}                        
                    >
                        PAYMENT CONFIRMATION
                    </Button>
                   
                </Col>                    
            </div>
        )
    }
}
